export default __webpack_public_path__ + "images/0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b.png";